import React from 'react';
import Loader from 'components/loader';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';

const SearchPanelHeader = ({ title, isSearching, isLoading }) => {
    return (
        <div className="grid--row search-panel-header">
            <div className="grid--col">
                <h1 className="search-panel-header--title u-reset">{title}</h1>
            </div>
            {isSearching || isLoading ? (
                <div className="grid--col">
                    <Loader size="small" />
                </div>
            ) : null}
        </div>
    );
};

SearchPanelHeader.propTypes = {
    title: PropTypes.string.isRequired,
    isSearching: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

SearchPanelHeader.defaultProps = {
    isLoading: false,
};

export default connect(
    reduxUtils.mapStateToProps({
        isSearching: 'search.isSearching',
    }),
    reduxUtils.mapDispatchToProps({})
)(SearchPanelHeader);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-header/search/search-panel-header/index.js